import React, { useState, useRef } from 'react';
import './index.less'
export default (props) => {
    const { recordArr } = props
    const MONTH = [null, 'Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.']
    // 按地区统计
    let areaarr = []
    let total = 0
    const datearr = recordArr[0]['开立日'].split('-')
    const mon = Number(datearr[1])
    recordArr.forEach(item => {
        // 判断区域
        let index = areaarr.findIndex(item2 => item2.area == item.area)
        let money = item['票据金额']
        total += money
        if (index != -1) {
            // 判断项目
            let subarr = areaarr[index].subarr
            let index2 = subarr.findIndex(item2 => item2.ch_proj == item['用途'])
            if (index2 != -1) {
                areaarr[index].subarr[index2].count += money
            } else {
                areaarr[index].subarr.push({
                    ch_proj: item['用途'],
                    en_proj: item.en_proj,
                    count: money
                })
            }
            areaarr[index].total += money
        } else {
            areaarr.push({
                area: item.area,
                subarr: [{
                    ch_proj: item['用途'],
                    en_proj: item.en_proj,
                    count: money
                }],
                total: money
            })
        }
    })
    return (
        <div className='monthInvoice' id='monthInvoice'>
            <h3>Buddhist Compassion Relief Tzu Chi Foundation Phils., Inc.</h3>
            <h3>Monthly Fund and Project Breakdown</h3>
            <div className='month'><span>Period: {MONTH[mon]}, {datearr[0]}</span><span>Currency Unit: PHP</span></div>
            {areaarr.map(item => {
                return (
                    <div key={item.area} className='areaItem'>
                        <div className='areaTitle'>Relief Fund ({item.area})</div>
                        {item.subarr.map(item2 => {
                            return (
                                <div key={item2.ch_proj} className='subItem'>
                                    <span>{item2.ch_proj + ' ' + item2.en_proj}</span>
                                    <span>{item2.count.toFixed(2)}</span>
                                </div>
                            )
                        })}
                        <div className='areaTotal'>
                            <div>{item.area} Total Relief Fund</div>
                            <div className='count'>{item.total.toFixed(2)}</div>
                        </div>
                    </div>
                )
            })}
            <div className='total'>
                <span>Grand Total for Dev.Fund</span>
                <span>{total.toFixed(2)}</span>
            </div>
        </div>
    )
}